module.exports = "https://www.niulinkcloud.cn/_next/static/media/douyin.2a566b2f9805182e82fde5aaaa99790d.png";